import React from "react";
import { useSelector } from "react-redux";
import { getQuestions } from "./../../features/Questions/questionSlice";
import "./question.css";
function QuestionBox() {
  const Questions = useSelector(getQuestions);
  // console.log(Questions);

  const questionCard = (item) => {
    let correct = item.ans === item.attempted;
    let left = item.attempted === "";

    return (
      <div
        className={`text-left result-question ${
          (correct && "correct") ||
          (left && "left-question") ||
          (!correct && !left && "incorrect")
        } `}
        key={item.id}
      >
        <p className="q-no ml-3 mt-1">
          {" "}
          <b> Q{item.id})</b>{" "}
        </p>
        <div className="result-question-img">
          <img
            id="img-result"
            src={item.src}
            alt={"question" + item.id}
            loading="lazy"
          />
        </div>
        <div className="img-text p-1">
          <p className="d-flex justify-content-around flex-wrap">
            {" "}
            <b> Correct : {item.ans.toUpperCase()} </b>
            <b>Attempted : {(item.attempted || "None").toUpperCase()} </b>
          </p>
          {/* (assume a : 1, b : 2, c : 3, d : 4) */}
          <p>
            {" "}
            Time given on this question :{" "}
            <b>{Math.round((item.time / 60000) * 100) / 100} min </b> or
            <b> {Math.round((Math.round((item.time / 60000) * 100) / 100) * 60)  } sec </b>
          </p>
        </div>
      </div>
    );
  };
  return (
    <div className="d-flex flex-wrap  justify-content-around questions-all ">
      {Questions.map(questionCard)}
    </div>
  );
}

export default QuestionBox;
